import publicRequest from '@/plugin/axios/request-public.js';

// 房屋类型
const houseType = [
  {
    optionValue: '商品住房',
    optionField: '',
    optionRemark: '',
    optionCode: '01'
  },
  {
    optionValue: '商住两用房',
    optionField: '',
    optionRemark: '',
    optionCode: '02'
  },
  {
    optionValue: '公寓',
    optionField: '',
    optionRemark: '',
    optionCode: '03'
  },
  {
    optionValue: '农村自建房',
    optionField: '',
    optionRemark: '',
    optionCode: '04'
  },
  {
    optionValue: '单位产权房',
    optionField: '',
    optionRemark: '',
    optionCode: '05'
  },
  {
    optionValue: '拆迁安置房',
    optionField: '',
    optionRemark: '',
    optionCode: '06'
  },
  {
    optionValue: '经济适用公寓',
    optionField: '',
    optionRemark: '',
    optionCode: '07'
  },
  {
    optionValue: '其他',
    optionField: '',
    optionRemark: '',
    optionCode: '08'
  }
];

// 房屋类别
const houseCategory = [
  {
    optionValue: '别墅',
    optionField: '',
    optionRemark: '',
    optionCode: '01'
  },
  {
    optionValue: '高层',
    optionField: '',
    optionRemark: '',
    optionCode: '02'
  },
  {
    optionValue: '小高层',
    optionField: '',
    optionRemark: '',
    optionCode: '03'
  },
  {
    optionValue: '多层',
    optionField: '',
    optionRemark: '',
    optionCode: '04'
  }
];

// 装修类型
const decorationType = [
  {
    optionValue: '毛坯装修',
    optionField: '',
    optionRemark: '',
    optionCode: '01'
  },
  {
    optionValue: '精装房软装',
    optionField: '',
    optionRemark: '',
    optionCode: '02'
  },
  {
    optionValue: '一体式交付软装',
    optionField: '',
    optionRemark: '',
    optionCode: '03'
  },
  {
    optionValue: '局部改造',
    optionField: '',
    optionRemark: '',
    optionCode: '04'
  }
];

// 硬装施工
const basicDecoration = [
  {
    optionValue: '拆旧完工',
    optionField: '',
    optionRemark: '',
    optionCode: '01'
  },
  {
    optionValue: '水电完工',
    optionField: '',
    optionRemark: '',
    optionCode: '02'
  },
  {
    optionValue: '泥工完工',
    optionField: '',
    optionRemark: '',
    optionCode: '03'
  },
  {
    optionValue: '木工完工',
    optionField: '',
    optionRemark: '',
    optionCode: '04'
  },
  {
    optionValue: '油漆完工',
    optionField: '',
    optionRemark: '',
    optionCode: '05'
  },
  {
    optionValue: '硬装收尾',
    optionField: '',
    optionRemark: '',
    optionCode: '06'
  },
  {
    optionValue: '硬装完工',
    optionField: '',
    optionRemark: '',
    optionCode: '07'
  },
  {
    optionValue: '其他',
    optionField: '',
    optionRemark: '',
    optionCode: '08'
  }
];

// 设备安装
const facilityDecoration = [
  {
    optionValue: '中央空调外机',
    optionField: '',
    optionRemark: '',
    optionCode: '01'
  },
  {
    optionValue: '地暖管道及分水器',
    optionField: '',
    optionRemark: '',
    optionCode: '02'
  }
];

// 软装配置
const electricalDecoration = [
  {
    optionValue: '电视',
    optionField: '',
    optionRemark: '',
    optionCode: '01'
  },
  {
    optionValue: '空调',
    optionField: '',
    optionRemark: '',
    optionCode: '02'
  },
  {
    optionValue: '洗衣机',
    optionField: '',
    optionRemark: '',
    optionCode: '03'
  },
  {
    optionValue: '冰箱',
    optionField: '',
    optionRemark: '',
    optionCode: '04'
  },
  {
    optionValue: '灶具',
    optionField: '',
    optionRemark: '',
    optionCode: '05'
  },
  {
    optionValue: '油烟机',
    optionField: '',
    optionRemark: '',
    optionCode: '06'
  },
  {
    optionValue: '无家电',
    optionField: '',
    optionRemark: '',
    optionCode: '07'
  },
  {
    optionValue: '其他',
    optionField: '',
    optionRemark: '',
    optionCode: '08'
  }
];

// 软装配置-家具类
const furnitureDecoration = [
  {
    optionValue: '沙发',
    optionField: '',
    optionRemark: '',
    optionCode: '01'
  },
  {
    optionValue: '床',
    optionField: '',
    optionRemark: '',
    optionCode: '02'
  },
  {
    optionValue: '衣柜',
    optionField: '',
    optionRemark: '',
    optionCode: '03'
  },
  {
    optionValue: '餐桌椅',
    optionField: '',
    optionRemark: '',
    optionCode: '04'
  },
  {
    optionValue: '无家具',
    optionField: '',
    optionRemark: '',
    optionCode: '05'
  },
  {
    optionValue: '其他',
    optionField: '',
    optionRemark: '',
    optionCode: '06'
  }
];

// 调查意见
const surveyOpinion = [
  {
    optionValue: '正常装修',
    optionField: '',
    optionRemark: '',
    optionCode: '01'
  },
  {
    optionValue: '存在疑点',
    optionField: '',
    optionRemark: '',
    optionCode: '02'
  }
];

// 具体疑点
const surveyOpinionDetail = [
  {
    optionValue: '楼盘状态异常',
    optionField: '',
    optionRemark: '',
    optionCode: '01'
  },
  {
    optionValue: '房屋地址异常',
    optionField: '',
    optionRemark: '',
    optionCode: '02'
  },
  {
    optionValue: '施工不符合正常程序',
    optionField: '',
    optionRemark: '',
    optionCode: '03'
  },
  {
    optionValue: '材料粗劣',
    optionField: '',
    optionRemark: '',
    optionCode: '04'
  },
  {
    optionValue: '未开工或已入住',
    optionField: '',
    optionRemark: '',
    optionCode: '05'
  },
  {
    optionValue: '装修用途非家庭居住',
    optionField: '',
    optionRemark: '',
    optionCode: '06'
  },
  {
    optionValue: '其他',
    optionField: '',
    optionRemark: '',
    optionCode: '07'
  }
];

// 查询车辆详情
export async function getSurveyReport(data) {
  return await publicRequest({
    url: '/vasCommon/h5/common/dict/queryByCodes',
    method: 'post',
    data
  });
}

export default {
  houseType,
  houseCategory,
  decorationType,
  basicDecoration,
  facilityDecoration,
  electricalDecoration,
  furnitureDecoration,
  surveyOpinion,
  surveyOpinionDetail
};
